import { Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SettlementsService } from 'src/app/services/settlements.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BreadcrumbService } from 'xng-breadcrumb';
import { PaymentsService } from 'src/app/services/payments.service';
import { environment } from 'src/environments/environment';
import { SupportService } from 'src/app/services/support.service';
import { ImageService } from 'src/app/shared/services/image.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { CatalogsService } from 'src/app/shared/services/catalogs.service';

import { ModalAddConceptBillComponent } from 'src/app/components/modals/modal-add-concept-bill.component';
import { Bill } from 'src/app/models/bill.model';
import { BillItem } from 'src/app/models/bill-item.model';
import { Unit } from 'src/app/models/unit.model';
import { Settlement } from 'src/app/models/settlement.model';
import { Building } from 'src/app/models/building.model';
import * as bs from 'bootstrap';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { FormCustomGasMeterReadComponent } from 'src/app/components/forms/form-custom-gas-meter-read.component';
import {
  buildReconnectionFeePreviewItem,
  findActiveReconnectionFee,
  RECONNECTION_FEE_ITEM_TYPE,
  resolveReconnectionFee,
  roundCurrency
} from 'src/app/shared/utils/reconnection-fee.utils';

@Component({
  selector: 'app-create-custom-bill',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Condominios y comercial</h1>
      </div>
    </div>
    <div class="d-flex mb-4">
      <div class="me-3 d-none d-md-block">
        <ul app-nav-settlements class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill mx-2 mx-sm-0">
        <div class="d-flex">
          <div class="flex-fill">
            <h5>Crear recibo</h5>
          </div>
        </div>
        <div class="d-flex mt-2">
          <div class="flex-fill" style="min-width: 440px !important; width: 440px !important;">
            <form [formGroup]="billForm" >
              <div class="list-group">
                <div class="list-group-item py-3">
                  <div class="d-flex">
                    <div>
                      <h2 class="mb-0">{{unit?.name}}</h2>
                      <h4 class="mb-0" style="font-size: 18px;">{{settlement?.name}}</h4>
                      <h3 style="font-size: 16px;">{{building?.name}}</h3>
                    </div>
                    <div class="ms-auto text-end" *ngIf="bill?.id">
                      <h4># {{bill?.id}}</h4>
                      <div class="badge" [ngClass]="getState(bill?.state)">{{getStatus(bill?.state)}}</div><br>
                      <div class="badge" [ngClass]="getBillStatus(bill?.status)">{{billStatus(bill?.status)}}</div><br>
                      <div class="badge bg-info" *ngIf="bill?.invoiced">Facturado</div>
                    </div>
                  </div>
                  <div class="mt-3">
                    <table class="table table-sm mb-0" style="font-size: 0.8em;">
                      <tr>
                        <th>Inquilino</th>
                        <td class="text-end">{{tenant?.name}} {{tenant?.last_name}}</td>
                      </tr>
                      <tr>
                        <th>C.P.</th> 
                        <td class="text-end">{{fiscal?.zip_code}}</td>
                      </tr>
                      <tr>
                        <th class="mb-0">RFC</th> 
                        <td class="text-end">{{fiscal?.rfc}}</td>
                      </tr>
                      <tr>
                        <th>Razón social</th> 
                        <td class="text-end">{{fiscal?.razon_social}}</td>
                      </tr>                    
                      <tr>
                        <th>Régimen fiscal</th>
                        <td *ngIf="fiscal?.regimen_fiscal" class="text-end">{{regimenFiscal(fiscal?.regimen_fiscal).id}} - {{regimenFiscal(fiscal?.regimen_fiscal).name}}</td>
                      </tr>
                      <tr>
                        <th>Uso del CFDI</th>
                        <td *ngIf="fiscal?.uso_cfdi" class="text-end">{{usocfdi(fiscal?.uso_cfdi).id}} - {{usocfdi(fiscal?.uso_cfdi).name}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="list-group-item py-3" *ngIf="!bill?.adv || bill?.state===0">
                  <div class="clearfix">
                    <h5 class="float-start mt-2">Servicios</h5>
                    <div class="float-end">
                      <button type="button" (click)="addConcept()" class="btn btn-sm btn-zazz-dark" > <!-- *ngIf="bill?.state==0" -->
                        <fa-icon [icon]="icons.faPlus"></fa-icon>
                      </button>
                    </div>
                  </div>
                  <div
                    *ngIf="reconnectionFeeAmount !== null"
                    class="d-flex align-items-center justify-content-between border-top mt-3 pt-3"
                  >
                    <div>
                      <strong>Cargo por reconexión</strong>
                      <div class="text-secondary text-sm">{{reconnectionFeeAmount | currency: 'MXN': 'symbol-narrow'}}</div>
                    </div>
                    <button
                      type="button"
                      class="btn btn-sm"
                      [ngClass]="reconnectionFeeSelected ? 'btn-outline-danger' : 'btn-zazz-dark'"
                      (click)="toggleManualReconnectionFee()"
                      [attr.aria-label]="reconnectionFeeSelected ? 'Quitar cargo por reconexión' : 'Agregar cargo por reconexión'"
                    >
                      {{reconnectionFeeSelected ? 'Quitar' : 'Agregar'}}
                    </button>
                  </div>
                </div>
                <div class="list-group-item py-3">
                  <h5>Medidores de gas</h5>
                  <div class="list-group" *ngFor="let gas_meter of unit?.gas_meters">
                    <div app-form-custom-gas-meter-read 
                      [gas_meter]="gas_meter" 
                      [unit]="unit"
                      (gasMeterAdded)="receiveGasMeterData($event)"
                      class="list-group-item"
                    ></div>
                  </div>
                </div>

                <div class="list-group-item py-3" *ngIf="billForm">
                  <div class="form-group mt-2">
                    <label for="reference" class="form-control-label">Referencia</label>
                    <input type="text" formControlName="reference" class="form-control">
                    <div *ngIf="bfc['reference'].touched && bfc['reference'].invalid">
                      <div *ngIf="bfc['reference'].errors?.['required']" class="text-danger text-sm">La referencia es requerida.</div>
                    </div>
                  </div>
                  <div class="form-group mt-2">
                    <label for="periodo_inicio" class="form-control-label">Inicio de periodo</label>
                    <input type="date" formControlName="periodo_inicio" class="form-control" formControlName="periodo_inicio">
                    <div *ngIf="bfc['periodo_inicio'].touched && bfc['periodo_inicio'].invalid">
                      <div *ngIf="bfc['periodo_inicio'].errors?.['required']" class="text-danger text-sm">El inicio de periodo es requerido.</div>
                    </div>
                  </div>
                  <div class="form-group mt-2">
                    <label for="periodo_fin" class="form-control-label">Fin de periodo</label>
                    <input type="date" formControlName="periodo_inicio" class="form-control" formControlName="periodo_fin">
                    <div *ngIf="bfc['periodo_fin'].touched && bfc['periodo_fin'].invalid">
                      <div *ngIf="bfc['periodo_fin'].errors?.['required']" class="text-danger text-sm">El fin de periodo es requerido.</div>
                    </div>
                  </div>
                </div>
                


                <div class="list-group-item py-3">
                  <div class="form-group">
                    <label for="description" class="form-control-label">Comentarios</label>
                    <textarea formControlName="description" class="form-control"></textarea>
                  </div>
                </div>
                <div class="list-group-item py-3">
                  <div class="d-flex">
                    <div class="flex-fill">
                      <p class="">{{loadingMsg}}</p>
                    </div>
                    <div>
                      <button class="btn btn-zazz-dark" *ngIf="bfc['id'].value==null" (click)="createBill()">
                        <fa-icon [icon]="icons.faSave" *ngIf="!loading" class="me-2"></fa-icon>
                        <fa-icon [icon]="icons.faCircleNotch" *ngIf="loading" animation="spin" class="me-2"></fa-icon>
                        Generar recibo
                      </button>
                      <div ngbDropdown class="d-inline-block" *ngIf="bfc['id'].value!=null">
                        <button type="button" class="btn btn-outline-success rounded-5 btn-lg" id="dropdownBasic1" ngbDropdownToggle [disabled]="loading">
                          <fa-icon [icon]="icons.faSave" *ngIf="!loading" class="me-2"></fa-icon>
                          <fa-icon [icon]="icons.faCircleNotch" *ngIf="loading" animation="spin" class="me-2"></fa-icon>
                          Actualizar recibo
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                          <div *ngIf="bill?.total==0">
                            <button ngbDropdownItem [disabled]="bill?.state==1" (click)="payBill()">Marcar como pagado</button>
                          </div>
                          <div *ngIf="bill?.total!>0">
                            <button ngbDropdownItem (click)="regenerateReceipt()" *ngIf="bfc['state']?.value === 1" [disabled]="transaction?.transaction_id">Reemitir Recibo</button>
                            <button ngbDropdownItem *ngIf="bfc['invoiced']?.value == true" (click)="regenerateInvoice()">Regenerar factura</button>
                            <button ngbDropdownItem [disabled]="bfc['state']?.value === 1 || bfc['total']?.value < 0" (click)="publishBill()">Emitir Recibo</button>
                            <button ngbDropdownItem *ngIf="!bill?.invoiced" (click)="configInvoice()">Emitir Factura</button> <!-- [disabled]="bfc['state'].value === 1" -->
                            <!-- && bfc['invoiced'].value === true -->
                          </div>
                          <button ngbDropdownItem (click)="updateBill()" *ngIf="!bill?.invoiced" >Guardar borrador</button>
                          <!-- button ngbDropdownItem (click)="resendBill()">Reenviar correo</!-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="ms-2" style="width: 485px !important; min-width: 485px !important;">
            <div class="list-group">
              <div class="list-group-item py-3" *ngIf="!bill?.adv">
                <app-receipt-breakdown
                  [bfc]="bfc"
                  [bill]="bill"
                  [bill_items]="bill?.bill_items ?? null"
                  [prev_bill]="prev_bill"
                  [interests]="5"
                ></app-receipt-breakdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-modal-invoice-config 
      [loading]="loading" 
      (saveInvoice)="publishInvoice($event)"
    ></app-modal-invoice-config>
    <app-modal-add-concept-bill 
      [concepts]="concepts" 
      (conceptData)="saveConcept($event)"
    ></app-modal-add-concept-bill>
  `,
  styleUrls: []
})
export class CreateCustomBillComponent {
  bill: Bill | null = null;
  bill_items: BillItem[] | null = null;
  prev_bill: Bill | null = null;
  transaction: any = {};
  unit: Unit | null = null;
  settlement: Settlement | null = null;
  building: Building | null = null;
  buildings: Building[] = [];
  billForm: FormGroup = new FormGroup({});
  loading: boolean = false;
  reconnectionFeeSelected: boolean = false;
  utilities: any[] = [];
  
  selectedBuilding: any = {};
  selectedFloor: any = {};
  selectedUnit: any = {};
  selectedUtility: any = {};
  profile: any = {};
  permissions: any = {};
  // meterImages: any = null;
  concepts: any[] = [];
  // additionalConcepts: any[] = [];

  loadingMsg: string = '';

  addingConcept: boolean = false;

  apiUrl: string = environment.AWS_REST_WSPREFIX;
  token_ca: any;

  utilityData: any = null;

  invoiceForm: FormGroup = new FormGroup({});

  factor: number = 0;
  admon: number = 0;
  price: number = 0;
  adeudos: number = 0;
  recargos: number = 0;
  descuento: number = 0;
  interests: number = 0;
  tanque: any = null;

  tenant: any = null;
  fiscal: any = null;

  medidor: any = null;
  prev_medidor: any = null;

  invoiceData: any = {};
  conceptos: any = [];
  // additionalConcepts: any = [];
  serie: string = '';
  // formapago: string = '';
  complemento: any = {};

  @ViewChild(ModalAddConceptBillComponent) modalAddConceptBill !: ModalAddConceptBillComponent;
  storageService = inject(StorageService);
  gasMeterUpdated = signal<boolean>(false);
  @ViewChild(FormCustomGasMeterReadComponent) formCustomGasMeter!: FormCustomGasMeterReadComponent;
  constructor(
    private store: SettlementsService,
    private paymentService: PaymentsService,
    private route: Router,
    private activateRoute: ActivatedRoute,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private support: SupportService,
    private image: ImageService,
    private breadcrumbService: BreadcrumbService,
    public icons: IconsService,
    public catalog: CatalogsService,
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS);

    this.activateRoute.params.subscribe((params: any) => {
      this.loading = true;

      console.log('params => ', params['id']);
      if (params['id'] != null) {

        this.store.getUnit(params['id']).subscribe((unit: any) => {
          console.log('Unit => ', unit);
          this.unit = unit;
        });

        this.store.getUnitSettlement(params['id']).subscribe(async (response: any) => {
          this.settlement = response.settlement;
          this.building = response.building;
          // this.unit = response.unit;
          this.tenant = response.tenants;
          this.fiscal = response.fiscal;
          this.invoiceForm.patchValue(this.fiscal);

          if (this.settlement?.merchant_id == 'actnet') {
            let token: any = `${this.profile.razon_social}_TOKEN_CA`;
            this.token_ca = environment[token as keyof typeof environment];
          }

          this.store.getProfile(this.profile.utility_id).subscribe(async (profile: any) => {              
            this.utilityData = profile;
            // TODO: add profile series
            this.serie = 'MAER'; // profile.series;
            //
            if (this.utilityData.logo) {
              let logo: any = await this.image.getBase64ImageFromUrl(this.image.buildURL(this.utilityData.logo));
              this.utilityData.logo = logo.error ? '/assets/images/empty-image.jpg' : "data:image/jpeg;base64," + logo.split(',')[1];
            }
          });
        });

        this.loading = false;
      }
    });
  }

  receiveGasMeterData(event: any) {
    this.gasMeterUpdated.set(true);
    const billItems = (this.bill?.bill_items ?? []).filter(
      item => item.item_type !== RECONNECTION_FEE_ITEM_TYPE
    );
    if (this.bill) {
      const subtotal = parseFloat((event.consumo_lt * event.gas_price).toFixed(2));
      this.bill = {
        ...this.bill,
        sub_total: subtotal,
        taxes: parseFloat((subtotal * 0.16).toFixed(2)),
        total: event.consumo_total,
        bill_items: billItems
      }
    } else {
      
      this.bill = {
        ...({} as Bill),
        sub_total: parseFloat((event.consumo_total - event.consumo_total * 0.16).toFixed(2)),
        taxes: parseFloat((event.consumo_total * 0.16).toFixed(2)),
        total: event.consumo_total,
        bill_items: billItems
      };
    }
    this.syncManualReconnectionPreview();
  }

  getStatus(status: any) {
    switch (status) {
      case 0:
        return 'Borrador';
      case 1:
        return 'Emitido';
      case 3:
        return 'Cancelado';
      case 4:
        return 'Pendiente';
      default:
        return 'N/A';
    }
  }

  getState(status: any) {
    switch (status) {
      case 0:
        return 'bg-warning';
      case 1:
        return 'bg-success';
      case 3:
        return 'bg-danger';
      case 4:
        return 'bg-info';
      default:
        return 'bg-secondary';
    }
  }

  billStatus (status: any) {
    switch (status) {
      case true:
        return 'Pagado';
      case false:
        return 'No pagado';
      default:
        return 'No pagado';
    }
  }

  getBillStatus (status: any) {
    switch (status) {
      case true:
        return 'bg-success';
      case false:
        return 'bg-danger';
      default:
        return 'bg-danger';
    }
  }

  usocfdi(uso_cfdi: any) {
    let finder = this.catalog.usosCFDI.find((uso: any) => uso.id == uso_cfdi);
    return finder;
  }

  regimenFiscal(regimen: any) {
    let finder = this.catalog.regimenes.find((reg: any) => reg.id == regimen);
    return finder;      
  }

  currReadFocusOut() {
    // if (this.bill.state==0) {
      this.calculateTotal();
    // }
  }

  ngOnInit(): void {
    this.buildForm();
    this.initForm();
  }

  protected addConcept(): void {
    // this.addingConcept = true;
    const modalTemplate: any | undefined = this.modalAddConceptBill;
    if (modalTemplate) {
      this.modalAddConceptBill.openModal(modalTemplate['modalAddConceptBill']);
    }
  }

  protected get reconnectionFeeAmount(): number | null {
    return resolveReconnectionFee(this.unit, this.settlement);
  }

  protected toggleManualReconnectionFee(): void {
    if (this.reconnectionFeeAmount === null) {
      return;
    }

    if (!this.bill) {
      this.bill = {
        id: 0,
        state: 0,
        status: false,
        invoiced: false,
        retry: 0,
        sub_total: 0,
        taxes: 0,
        total: 0,
        bill_items: []
      } as Bill;
    }

    this.reconnectionFeeSelected = !this.reconnectionFeeSelected;
    this.syncManualReconnectionPreview();
  }

  private syncManualReconnectionPreview(): void {
    if (!this.bill) {
      return;
    }

    const currentItem = findActiveReconnectionFee(this.bill.bill_items);
    const billItems = (this.bill.bill_items ?? []).filter(
      item => item.item_type !== RECONNECTION_FEE_ITEM_TYPE
    );
    let subtotal = Number(this.bill.sub_total ?? 0);
    let taxes = Number(this.bill.taxes ?? 0);
    let total = Number(this.bill.total ?? 0);

    if (currentItem) {
      subtotal -= Number(currentItem.net_price ?? currentItem.price ?? 0);
      taxes -= Number(currentItem.tax_amount ?? 0);
      total -= Number(currentItem.total ?? 0);
    }

    if (this.reconnectionFeeSelected && this.reconnectionFeeAmount !== null) {
      const previewItem = buildReconnectionFeePreviewItem(this.reconnectionFeeAmount);
      billItems.push(previewItem);
      subtotal += Number(previewItem.net_price ?? previewItem.price ?? 0);
      taxes += Number(previewItem.tax_amount ?? 0);
      total += Number(previewItem.total ?? 0);
    }

    this.bill = {
      ...this.bill,
      sub_total: roundCurrency(subtotal),
      taxes: roundCurrency(taxes),
      total: roundCurrency(total),
      bill_items: billItems
    };
  }

  protected saveConcept(billItem: any): void {
    console.log('SAVE CONCEPT =====> ', billItem);

    billItem.bill_id = this.billForm.value.id;
    billItem.sku = `${this.profile.rfc.substring(0, 3)}-${this.settlement?.id}-SRV`;

    console.log('BILL ITEM =====> ', billItem);
    this.store.addBillItem(billItem).subscribe({
      next: (data: any) => {
        console.log('Bill item added successfully', data);
        this.toastr.success('Concepto agregado correctamente', 'Éxito');
        // this.loadBill(this.billForm.value.id);
      }, error: (err: any) => {
        console.log('Error adding bill item', err);
        this.toastr.error('Error al agregar concepto', 'Error');
      }
    });
  }

  removeConcept(index: any) {
    // TODO: remove concept from bill
  }



  buildForm() {
    this.billForm = this.fb.group({
      id: [null],
      reference: ['', Validators.required],
      description: [null],
      status: [''],
      consumo_m3: [''],
      consumo_lt: [''],
      consumo_periodo: [''],
      consumo_total: [''],
      taxes: [''],
      sub_total: [''],
      total: [''],
      days: [''],
      periodo_inicio: ['', Validators.required],
      periodo_fin: ['', Validators.required],
      due_date: [''],
      paid_date: [''],
      subscription_id: [''],
      unit_id: [''],
      settlement_id: [''],
      state: [''],
      pdf: [null],
      adv: [''],
      created_at: [''],
      updated_at: [''],
    });    
  }

  initForm() {
    this.invoiceForm = this.fb.group({
      rfc: ['', Validators.required],
      razon_social: ['', Validators.required],
      regimen_fiscal: ['', Validators.required],
      uso_cfdi: ['', Validators.required],
      zip_code: ['', Validators.required],
    });    
  }

  get bfc () {
    return this.billForm.controls;
  }

  calculateTotal(): void {
    this.loading = true;
    // const read_prev = this.billForm.value.read_prev;
    // const read_curr = this.billForm.value.read_curr;

    if (this.billForm.invalid) {
      this.toastr.error('Llena todos los campos requeridos.', 'Error');
      this.billForm.markAllAsTouched();
      this.loading = false;
      return;
    }

    // TODO: Refactor
    this.store.getBillCalculationLts({
      unit_id: this.unit?.id,
      settlement_id: this.settlement?.id,
      bill_id: this.billForm.value.id,
      // additional_services: this.additionalConcepts,
      read_curr: this.billForm.value.read_curr,
      periodo_inicio: this.billForm.value.periodo_inicio,
      periodo_fin: this.billForm.value.periodo_fin,
    }).subscribe({
      next: (calculation: any) => {
        this.billForm.patchValue({
          consumo_m3: calculation.consumo_m3,
          consumo_lt: calculation.consumo_lt,
          consumo_periodo: calculation.consumo_periodo,
          consumo_total: calculation.consumo_total,
          sub_total: calculation.sub_total,
          admin_price: calculation.admin_price,
          discount: calculation.discount,
          taxes: calculation.taxes,
          total: calculation.total,
          interests: calculation.interests,
          recargos: calculation.recargos,
          days: calculation.days,
          due_date: calculation.due_date,
          periodo_inicio: calculation.periodo_inicio.split('T')[0],
          periodo_fin: calculation.periodo_fin.split('T')[0],
          additional_services: calculation.additional_services ? JSON.stringify(calculation.additional_services) : null,
          subscription_id: calculation.subscription_id,
          unit_id: calculation.unit_id,
          state: calculation.state,
          status: calculation.status,
          // due_date: datte.toISOString().substring(0, 10)
        });

        console.log('calculateTotal => ', this.billForm.value);

        this.loading = false;
        this.toastr.success('Cálculo del recibo actualizado correctamente', 'Éxito');
      }, error: (err: any) => {
        console.log('calculateTotal ERROR => ', err);
        this.toastr.error('Ocurrió un error al calcular el recibo', 'Error');
        this.loading = false;
      }
    });
  }

  configInvoice() {
    new bs.Modal(<HTMLInputElement>document.getElementById('modalInvoiceConfig')).show();
  }

  async publishBill() {
    this.loading = true;
    this.loadingMsg = 'Recopilando información del recibo..';

    if (this.billForm.invalid) {
      this.billForm.markAllAsTouched();
      this.toastr.error('Favor de llenar todos los campos', 'Error');
      this.loadingMsg = '';
      this.loading = false;
      return;
    }

    this.billForm.patchValue({
      status: false,
      adv: false,
    });

    let dueDate = new Date(this.bill?.due_date!);
    dueDate.setDate(dueDate.getDate());
    dueDate.toISOString().substring(0, 10);

    let rtry: string = this.bill?.retry! > 0 ? `-${this.bill?.retry!}` : '';

    this.billForm.patchValue({
      merchant_id: this.settlement?.merchant_id
    });

    await this.updateBill();

    // this.bill.medidor = this.meterImages;
    let paymanetData: any = {}
    let receiptPayload = {
      bill: this.billForm.value,
      dueDate: dueDate,
      unitData: this.unit,
      buildingData: this.settlement,
      paymentData: paymanetData,
      utilityData: this.utilityData,
      tenantData: this.tenant,
    };

    const default_cus: string = `${this.profile.razon_social}_DEFAULT_CUS`;
    const generic_default_cus = environment[default_cus as keyof typeof environment];

    const payload = {
      process_token: this.token_ca, 
      unique_payment: true,
      transaction_id: `${this.billForm.value.id}-C${rtry}`, // payData.transaction_id,
      description: this.billForm.value.reference,
      expiration_interval_days: "5",
      currency_code: "MXN",
      amount: this.billForm.value.total?.toFixed(2),
      ip_address: "201.207.239.230",
      customer_username: this.tenant ? this.tenant.usename : 'ZAZZ', 
      first_name: this.tenant ? this.tenant.name : 'Administrador',
      last_name: this.tenant ? this.tenant.last_name : 'ZAZZ',
      email: this.tenant ? this.tenant.email : 'grupo.centurion.tech@gmail.com',
      phone: this.tenant ? this.tenant.phone : '5555555555',
      country: "MX",
      state: "CX",
      city: "CDMX",
      address: this.settlement?.address,
      zip_code: this.settlement?.zip,
      profile_id: this.profile.id,
      customer_id: this.tenant ? this.tenant.customer_id : generic_default_cus
    };

    let payment: any = null;

    console.log("PAYLOAD ====================> ", payload);
    // return;
    this.loadingMsg = `Comunicando con el motor de pago ${this.settlement?.merchant_id}...`;
    if (this.settlement?.merchant_id == 'actnet') {
      payment = await this.merchantActnet(payload);
      receiptPayload.paymentData.transaction_id = payment.transaction_id; // .id;
    } else if (this.settlement?.merchant_id == 'openpay') {

      if (this.tenant && !this.tenant.customer_id) {
        let customer: any = await this.merchantOpenpayCustomer(this.tenant);
        payload.customer_id = customer.id;
      }

      payment = await this.merchantOpenpay(payload);
      receiptPayload.paymentData.transaction_id = payment.payment_method.reference;
      // 
      let barcode: any = await this.image.getBase64ImageFromUrl(payment.payment_method.barcode_url);
      receiptPayload.paymentData.barcode = "data:image/jpeg;base64," + barcode.split(',')[1];
    }
    receiptPayload.paymentData.merchant_id = this.settlement?.merchant_id;
    
    console.log('Payment =======================> ', payment);
    if (!payment) {
      this.toastr.error('Ocurrió un error al procesar el pago.', 'Error');
      this.loadingMsg = '';
      this.loading = false;
      return;
    }


    this.loadingMsg = 'Respuesta exitosa, creando transacción...';

    await this.createCashTransaction({
      bill_id: this.bill?.id,
      transaction_id: payment.transaction_id,
      amount: this.billForm.value.total?.toFixed(2),
      external_transaction_id: payload.transaction_id,
    });
    await this.createReceipt(receiptPayload);
    this.loadingMsg = 'Creando recibo...';

    this.store.publishBill(this.bill?.id, this.billForm.value).subscribe({
      next: (data: any) => {
        this.toastr.success('Recibo emitido correctamente.', 'Éxito');
        this.loadingMsg = '';
        this.loading = false;
        this.route.navigate(['/pagos/pendientes']);
      },
      error: (err: any) => {
        console.log('publishBill ERROR => ', err);
        this.loadingMsg = '';
        this.toastr.error(`Ocurrió un error al emitir el recibo. ${err}`, 'Error');
        this.loading = false;
      }
    });
  }

  protected async merchantOpenpayCustomer(tenant: any) {
    console.log('merchantOpenpayCustomer => ', tenant);
    let payload: any = {};
    payload = tenant;
    payload.profile_id = this.profile.id;
    return await this.paymentService.createOpenpayCustomer(payload);
  }

  publishInvoice(configs: any) {

    console.log('PUBLISH INVOICE configs =>', configs.metodo);

    if (this.invoiceForm.invalid) {
      this.toastr.error('No existe información de facturación del RECEPTOR, debes agregar al responsable/inquilino con su información fiscal del local.', 'Error');
      return;
    }

    let subtotal_service = 0;
    // this.additionalConcepts.map((concept: any) => {
      // subtotal_service += parseFloat(concept.cantidad);
    // });
    
    console.log("bill => ", this.billForm.value.due_date);

    let dueDate = new Date(this.billForm.value.due_date);
    dueDate.setDate(dueDate.getDate());
    dueDate.toISOString().substring(0, 10);

    // this.billForm.value.medidor = this.meterImages;

    let receiptPayload = {
      bill: this.billForm.value,
      dueDate: dueDate,
      unitData: this.unit,
      utilityData: this.utilityData,
      buildingData: this.settlement
    };

    console.log("receiptPayload => ", receiptPayload);
    console.log('billForm => ', this.billForm.value);
    console.log('invoiceForm => ', this.invoiceForm.value);

    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const tn = tzoffset + 3600000;
    const localISOTime = (new Date(Date.now() - tn)).toISOString();

    console.log("localISOTime => ", localISOTime);

    let encabezados: any = {
      CFDIsRelacionados: "",
      TipoRelacion: "04",
      Receptor:{
        RFC: this.invoiceForm.value.rfc,
        NombreRazonSocial: this.invoiceForm.value.razon_social,
        UsoCFDI: this.invoiceForm.value.uso_cfdi,
        RegimenFiscal: this.invoiceForm.value.regimen_fiscal,
        Direccion: {
          Calle: "",
          NumeroExterior: "",
          NumeroInterior: "",
          Colonia: "",
          Localidad: "",
          Municipio: "",
          Estado: "",
          Pais: "",
          CodigoPostal: this.invoiceForm.value.zip_code
        }
      },
      // InformacionFacturaGlobal:{
        // Periodicidad: "02",
        // Meses: "09",
        // Año: 2024
      // },
      Fecha: localISOTime.slice(0,19),
      Serie: this.serie.toString(),
      Folio: this.billForm.value.id.toString(),
      MetodoPago: configs.metodoPago,
      FormaPago: configs.formaPago,
      Moneda: "MXN",
      LugarExpedicion: this.invoiceForm.value.zip_code,
      SubTotal: this.billForm.value.sub_total,
      Total: this.billForm.value.total,
    };

    this.complemento = {
      formaPago: configs.formaPago,
      serie: this.serie,
      folio: this.billForm.value.id,
      usoCFDI: this.invoiceForm.value.uso_cfdi,
      metodoPago: configs.metodoPago,
    }

    let payload: any = {
      bill: this.billForm.value,
      profile: this.profile,
      Encabezado: encabezados,
      Conceptos: this.billForm.value,
      complemento: this.complemento,
      utilityData: this.utilityData,
    };

    if (this.invoiceForm.invalid) {
      this.toastr.error('Completa toda la información requerida del formulario.', 'Error');
      this.loading = false;
      this.invoiceForm.markAllAsTouched();
      return;
    }

    console.log('PAYLOAD INVOICE ===> ', payload);

    this.store.createInvoice(payload).subscribe({
      next: (data: any) => {
        console.log(data);
        this.loading = false;
        this.invoiceData = data;
        this.download();
        this.toastr.success('Factura creada correctamente.', 'Éxito');
      },
      error: (err: any) => {
        console.log(err);
        if (err.status >= 500) {
          this.toastr.error('Ocurrió un error al crear la factura.', 'Error');
        }
        this.loading = false;
      }
    });
  }

  async regenerateReceipt() {
    let dueDate = new Date(this.bill?.due_date!);
    dueDate.setDate(dueDate.getDate());
    dueDate.toISOString().substring(0, 10);

    let paymanetData: any = {}

    let receiptPayload = {
      bill: this.billForm.value,
      dueDate: dueDate,
      unitData: this.unit,
      buildingData: this.settlement,
      paymentData: paymanetData,
      utilityData: this.utilityData,
      tenantData: this.tenant,
    };

    receiptPayload.paymentData.transaction_id = this.transaction.transaction_id;

    // console.log('receiptPayload => ', receiptPayload);
    await this.createReceipt(receiptPayload);
  }

  async regenerateInvoice() {
    console.log('regenerateInvoice ==> ', this.bill);
    if (this.bill?.invoice_id != null) {
      this.store.getInvoice(this.bill.invoice_id).subscribe({
        next: (data: any) => {
          this.invoiceData = data;
          this.download();
        },
        error: (err: any) => {
          console.log(err);
        }
      });
    }
  }

  async merchantActnet(payload: any) {

    let payment: any = await this.paymentService.createPaymentStoreActnet(payload);

    console.log('PAYMENT ACTNET => ', payment);

    if (payment != undefined && (payment.status_code == 4 || payment.transaction_id == null)) {
      console.log('paymentFailed => ', payment.error);
      this.toastr.error(`El motor de pago no logró la comunicación, por favor intentar más tarde. <br><br> <strong>${payment.error.error_message}</strong>`, 'Error', {
        enableHtml: true,
      });
      this.loadingMsg = 'Error de motor de pago...';
      this.store.updateFailedPayment(this.bill?.id).subscribe({
        next: (data: any) => {
          console.log('updateFailedPayment => ', data);
          this.billForm.patchValue(data);
        },
        error: (err: any) => {
          console.log('updateFailedPayment ERROR => ', err);
        }
      });
      // this.support.paymentFailed(payment.error);
      this.loadingMsg = '';
      this.loading = false;
      // window.location.reload();
      return null;
    }

    return payment;
  }

  async merchantOpenpay(payload: any) {
    let payment: any = await this.paymentService.createOpenpayStore(payload);

    if (payment != undefined && payment['ErrorCode']) {
      console.log('paymentFailed => ', payment.error);
      this.toastr.error(`El motor de pago no logró la comunicación, por favor intentar más tarde. <br><br> <strong>${payment['Description']}</strong>`, 'Error', {
        enableHtml: true,
      });
      this.loadingMsg = 'Error de motor de pago...';
      this.store.updateFailedPayment(this.bill?.id).subscribe({
        next: (data: any) => {
          console.log('updateFailedPayment => ', data);
          this.billForm.patchValue(data);
        },
        error: (err: any) => {
          console.log('updateFailedPayment ERROR => ', err);
        }
      });

      this.loadingMsg = '';
      this.loading = false;
      // window.location.reload();
      return null;
    }

    console.log('PAYMENT OPENPAY => ', payment);

    return payment;
  }

  async createReceipt(payload: any) {
    this.store.createReceipt(payload).subscribe({
      next: (data: any) => {
        console.log('CREATE RECEIPT !!!!!!!');
        this.store.saveReceipt(this.bill?.id, { pdf: data.filename }).subscribe((data: any) => {
          console.log('saveReceipt => ', data);
        });

        const int8Array = new Uint8Array(data.result.data);
        const blob = new Blob([int8Array], { type: 'application/pdf' });
        let fileURL = window.URL.createObjectURL(blob);
        let link = document.createElement('a');

        link.href = fileURL;
        link.download = data.filename;
        link.click();

        return;
      },
      error: (err: any) => {
        console.log('createReceipt ERROR => ', err);
        this.toastr.error('Ocurrió un error al crear el recibo', 'Error');
        this.loading = false;
      }
    });
  }

  download() {
    let dueDate = new Date(this.billForm.value.due_date);
    dueDate.setDate(dueDate.getDate());
    dueDate.toISOString().substring(0, 10);
    //
    this.store.downloadInvoice({
      bill: this.billForm.value,
      dueDate: dueDate,
      unitData: this.unit,
      settlementData: this.settlement,
      buildingData: this.building,
      utilityData: this.utilityData,
      invoiceData: this.invoiceData
    }).subscribe({
      next: (data: any) => {
        console.log('downloadInvoice => ', data.result.data);
        this.store.saveInvoicePdf(this.invoiceData.id, { pdf: data.filename });

        const int8Array = new Uint8Array(data.result.data);
        const blob = new Blob([int8Array], { type: 'application/pdf' });

        var fileURL = window.URL.createObjectURL(blob);
        var link=document.createElement('a');

        link.href = fileURL;
        link.download = data.filename;
        link.click();

        const blob2 = new Blob([this.invoiceData.cfdixml], { type: 'application/xml' });

        var fileURL2 = window.URL.createObjectURL(blob2);
        var link2=document.createElement('a');

        link2.href = fileURL2;
        link2.download = `${this.invoiceData.serie}_${this.invoiceData.folio}.xml`;
        link2.click();
        
        return;
      }, error: (error: any) => {
        this.toastr.error('Ocurrió un error al descargar la factura', 'Error');
        console.log('createReceipt ERROR => ', error);
      }
    });
  }

  payBill(): void {
    this.loading = true;

    if (this.billForm.invalid) {
      this.billForm.markAllAsTouched();
      this.toastr.error('Favor de llenar todos los campos', 'Error');
      this.loading = false;
      return;
    }

    this.billForm.patchValue({
      status: true
    });

    let dueDate = new Date(this.bill?.due_date!);
    dueDate.setDate(dueDate.getDate());
    dueDate.toISOString().substring(0, 10);

    // this.bill.medidor = this.meterImages;
    let paymanetData: any = {}

    let receiptPayload = {
      bill: this.billForm.value,
      dueDate: dueDate,
      unitData: this.unit,
      buildingData: this.settlement,
      paymentData: paymanetData,
      utilityData: this.utilityData,
    };

    receiptPayload.bill.transaction_id = Date.now();

    this.store.createReceipt(receiptPayload).subscribe({
      next: (data: any) => {
        const int8Array = new Uint8Array(data.result.data);
        const blob = new Blob([int8Array], { type: 'application/pdf' });
        let fileURL = window.URL.createObjectURL(blob);
        let link = document.createElement('a');

        link.href = fileURL;
        link.download = data.filename;
        link.click();

        this.billForm.patchValue({
          pdf: data.filename
        });

        this.store.publishBill(this.bill?.id, this.billForm.value).subscribe({
          next: (data: any) => {
            let payload: any = {
              transaction_id: receiptPayload.bill.transaction_id,
              amount: '0',
              currency: 'MXN',
              status_code: '3',
              error_code: '00',
              error_message: 'Approved',
              payment_method_bin: '0',
              payment_method_type: 'SALDO',
              payment_method_brand: 'SALDO',
              bill_id: this.bill?.id,
              external_transaction_id: this.bill?.id
            }

            this.store.createTransaction(payload).subscribe({
              next: (data: any) => {
                this.toastr.success('Recibo creado correctamente.', 'Éxito');
                this.loading = false;
                this.route.navigate(['/pagos/pendientes']);
              },
              error: (err: any) => {
                this.toastr.error('Ocurrió un error al crear el recibo', 'Error');
                this.loading = false;
              }
            });
          },
          error: (err: any) => {
            this.toastr.error('Ocurrió un error al crear el recibo', 'Error');
            this.loading = false;
          }
        });
      },
      error: (err: any) => {
        this.toastr.error('Ocurrió un error al crear el recibo', 'Error');
        this.loading = false;
      }
    });
  }

  protected async createBill() {
    if (!this.gasMeterUpdated()) {
      const consumo = this.formCustomGasMeter.gas_meter_form.controls['consumo_lt'];
      if (consumo.value) {
        try {
          const res = await this.formCustomGasMeter.onSubmitPromise();
          this.receiveGasMeterData(res);
        } catch (error) {
          console.log('createGasMeterRead ERROR => ', error);
          this.toastr.error('Ocurrió un error al crear la lectura del medidor', 'Error');
          this.loading = false;
        }
      } else {
        this.toastr.error('No se han agregado litros consumidos', 'Error');
        return;
      }
    }
    this.loading = true;

    if (this.billForm.invalid) {
      this.billForm.markAllAsTouched();
      this.toastr.error('Favor de llenar todos los campos', 'Error');
      this.loading = false;
      return;
    }

    this.billForm.patchValue({
      unit_id: this.unit?.id,
      settlement_id: this.settlement?.id,
    });

    this.store.createBillCustom(this.billForm.value).subscribe({
      next: (bill: any) => {
        console.log('createBillCustom => ', bill);
        // this.billForm.patchValue(bill);
        // this.billForm.patchValue({
          // periodo_inicio: data.periodo_inicio.split('T')[0],
          // periodo_fin: data.periodo_fin.split('T')[0],
        // });          
        const billId = bill?.data?.id ?? bill?.id;
        if (!this.reconnectionFeeSelected) {
          this.finishManualBillCreation(billId);
          return;
        }

        this.store.addBillItem({
          bill_id: billId,
          item_type: RECONNECTION_FEE_ITEM_TYPE
        }).subscribe({
          next: () => this.finishManualBillCreation(billId),
          error: (err: any) => {
            console.error('Error adding reconnection fee to manual bill', err);
            this.toastr.warning(
              'El recibo se creó, pero no fue posible agregar el cargo por reconexión. Puede intentarlo nuevamente desde el borrador.',
              'Cargo no agregado'
            );
            this.route.navigate(['/pagos/recibos/', billId]);
            this.loading = false;
          }
        });
      }, 
      error: (err: any) => {
        this.toastr.error('Favor de llenar todos los campos', 'Error');
        this.loading = false;
      }
    });
  }

  private finishManualBillCreation(billId: number): void {
    this.toastr.success('Recibo creado correctamente', 'Éxito');
    this.route.navigate(['/pagos/recibos/', billId]);
    this.loading = false;
  }

  protected updateBill(): void {
    this.loading = true;

    if (this.billForm.invalid) {
      this.billForm.markAllAsTouched();
      this.toastr.error('Favor de llenar todos los campos', 'Error');
      this.loading = false;
      return;
    }

    this.store.updateBill(this.billForm.value.id, this.billForm.value).subscribe({
      next: (data: any) => {
        this.toastr.success('Recibo actualizado correctamente', 'Éxito');
        // this.route.navigate(['/pagos/pendientes']);
        this.loading = false;
      }, 
      error: (err: any) => {
        this.toastr.error('Favor de llenar todos los campos', 'Error');
        this.loading = false;
      }
    });
  }

  async createCashTransaction(data: any) {
    let payload: any = {
      transaction_id: data.transaction_id,
      amount: data.amount,
      currency: 'MXN',
      status_code: '1',
      error_message: 'Pending',
      payment_method_bin: '0',
      payment_method_type: 'CASH',
      payment_method_brand: 'CASH',
      bill_id: data.bill_id,
      external_transaction_id: data.external_transaction_id
    }

    await this.store.createTransaction(payload).subscribe({
      next: (data: any) => {
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
      }
    });
  }
}
